var _circle, _ellipse, _ellipse2, _path, _path2, _path3, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmileyKnow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    enableBackground: "new 0 0 1024 1024",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000119098585377029575660000000642572400449022882_",
    cx: 512,
    cy: 512,
    r: 452.6073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53782C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#52772C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6967,
    style: {
      stopColor: "#4B732C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8282,
    style: {
      stopColor: "#3F6D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    style: {
      stopColor: "#2E642A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1F5B2A"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_00000119098585377029575660000000642572400449022882_)",
    cx: 512,
    cy: 512,
    r: 452.6
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3158 -0.9488 0.9488 0.3158 -33.5461 532.8659)",
    cx: 352.7,
    cy: 289.7,
    rx: 90.1,
    ry: 58.8
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9974 -7.137746e-02 7.137746e-02 0.9974 -22.0392 51.1918)",
    cx: 705.3,
    cy: 334,
    rx: 58.8,
    ry: 90.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B2182E",
    d: "M641.1,639.1c-34.7,26.1-82.8,42.3-149.3,33.9c-66.5-8.4-109.1-35.9-136.3-69.8 c-59.1-73.6-45.2-177-45.2-177l418.4,52.6C728.7,478.8,716.6,582.4,641.1,639.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E73E71",
    d: "M641.1,639.1c-34.7,26.1-82.8,42.3-149.3,33.9c-66.5-8.4-109.1-35.9-136.3-69.8 c34.7-26.1,82.8-42.3,149.3-34C571.3,577.6,613.9,605.2,641.1,639.1z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M310.3,426.2l418.4,52.6c0,0-119.5,26.7-207.2,13.5C439,479.9,310.3,426.2,310.3,426.2z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000034802452006753272100000005792948705040621502_",
    cx: 512,
    cy: 512,
    r: 506.6378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53782C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    style: {
      stopColor: "#52772C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6967,
    style: {
      stopColor: "#4B732C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8282,
    style: {
      stopColor: "#3F6D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9337,
    style: {
      stopColor: "#2E642A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    style: {
      stopColor: "#1F5B2A"
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "url(#SVGID_00000034802452006753272100000005792948705040621502_)",
    strokeWidth: 13.8,
    strokeMiterlimit: 10,
    cx: 512,
    cy: 512,
    r: 499.7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileyKnow);
export default __webpack_public_path__ + "static/media/smiley-know.0b5b7c78fac62111ab201fd603d2c876.svg";
export { ForwardRef as ReactComponent };